import { GraphQLClient } from 'graphql-hooks'

const graphQlClient = new GraphQLClient({
    url: process.env.REACT_APP_API_DOMAIN + '/api/v2',
    fetchOptions: { credentials: "include" },
    logErrors: false
})

export default graphQlClient